/*
 * Forte Plus v2 — product photos as a slider with arrows + autoplay (Kenan 2026-10-13:
 * «الصورة التانية ما تكون تحت… خليهم سلايد بيقلب باسهم او اوتوماتيكي»).
 *
 * Works on Dawn's media gallery in the «thumbnail_slider» layout (templates/product.json):
 *  · desktop: one photo at a time (Dawn shows only .is-active) — we switch the active photo and
 *    the thumbnail ourselves. Dawn's setActiveMedia() is NOT used: it scrolls the whole page to
 *    the photo, which would yank the page every few seconds during autoplay.
 *  · phone: the list is Dawn's horizontal scroll-snap slider — we scroll it sideways only.
 * Autoplay every 4 s, only while the gallery is on screen and the tab is visible; any touch,
 * hover, focus or arrow press pauses it for 8 s. Off for prefers-reduced-motion.
 */
(function () {
  'use strict';
  var DELAY = 4000, HOLD = 8000;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktopMq = window.matchMedia('(min-width: 750px)');

  function init(gallery) {
    if (gallery.__lt) return; gallery.__lt = true;
    var list = gallery.querySelector('.product__media-list');
    if (!list) return;
    var items = [].slice.call(list.querySelectorAll(':scope > .product__media-item'));
    if (items.length < 2) return;
    var thumbs = [].slice.call(gallery.querySelectorAll('.thumbnail-list__item'));
    var i = Math.max(0, items.findIndex(function (it) { return it.classList.contains('is-active'); }));
    var visible = false, held = 0, timer = 0;

    function currentMobile() {
      var x = list.scrollLeft, best = 0, d = Infinity;
      items.forEach(function (it, k) { var dd = Math.abs(it.offsetLeft - list.offsetLeft - x); if (dd < d) { d = dd; best = k; } });
      return best;
    }
    function show(k) {
      k = (k + items.length) % items.length;
      if (desktopMq.matches) {
        items.forEach(function (it, n) { it.classList.toggle('is-active', n === k); });
        thumbs.forEach(function (t, n) {
          var b = t.querySelector('button'); if (!b) return;
          if (n === k) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        });
      } else {
        list.scrollTo({ left: items[k].offsetLeft - list.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }
      i = k;
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === k); });
    }
    function hold() { held = Date.now() + HOLD; }
    function tick() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!reduce && visible && !document.hidden && Date.now() > held && !document.querySelector('product-modal[open]')) {
          if (!desktopMq.matches) i = currentMobile();
          show(i + 1);
        }
        tick();
      }, DELAY);
    }

    // arrows + dots, inside Dawn's slider-component (position: relative)
    var host = gallery.querySelector('slider-component') || gallery;
    var nav = document.createElement('div');
    nav.className = 'lt-gal';
    nav.innerHTML =
      '<button type="button" class="lt-gal__btn lt-gal__btn--prev" aria-label="Ankstesnė nuotrauka"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button type="button" class="lt-gal__btn lt-gal__btn--next" aria-label="Kita nuotrauka"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<div class="lt-gal__dots" aria-hidden="true">' + items.map(function () { return '<i></i>'; }).join('') + '</div>';
    host.appendChild(nav);
    var dots = [].slice.call(nav.querySelectorAll('.lt-gal__dots i'));
    nav.querySelector('.lt-gal__btn--prev').addEventListener('click', function () { hold(); if (!desktopMq.matches) i = currentMobile(); show(i - 1); });
    nav.querySelector('.lt-gal__btn--next').addEventListener('click', function () { hold(); if (!desktopMq.matches) i = currentMobile(); show(i + 1); });
    dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });

    // a thumbnail click (Dawn) or a swipe keeps our index in step and pauses autoplay
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { hold(); i = n; dots.forEach(function (d, m) { d.classList.toggle('is-on', m === n); }); }); });
    list.addEventListener('scroll', function () { if (!desktopMq.matches) { var k = currentMobile(); dots.forEach(function (d, m) { d.classList.toggle('is-on', m === k); }); } }, { passive: true });
    ['pointerenter', 'pointerdown', 'touchstart', 'focusin', 'wheel'].forEach(function (ev) { gallery.addEventListener(ev, hold, { passive: true }); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[es.length - 1].intersectionRatio >= 0.6; }, { threshold: [0, 0.6, 1] }).observe(list);
    } else { visible = true; }
    tick();
  }

  function boot() { [].forEach.call(document.querySelectorAll('media-gallery'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
